import { Loading } from 'react-daisyui';

export const MyLoading = () => {
  return (
    <div className='flex justify-center px-4 py-30'>
      <Loading />
    </div>
  );
}
